import React, { useCallback, useState, useRef, useEffect } from 'react';
import axios from '../axios';
import FeedItem from '../userfeeds/userfeed_item';

const ActiveUserfeedColumn = ({ currentUser, userfeedId, companyId, hashedCompanyId }) => {
  const [userfeeds, setUserfeeds] = useState([]);
  const [isLoadingNextList, setIsLoadingNextList] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLastPage, setIsLastPage] = useState(false);
  const scrollRef = useRef(null);
  const ancLastItemRef = useRef(null);
  const isEnableNextLoad = useRef(true);

  const loadNextList = useCallback(() => {
    if (isLoadingNextList || isLastPage) {
      return;
    }

    setIsLoadingNextList(true);

    const url = `/api/userfeeds/community/active?company_id=${companyId}&page=${currentPage}`

    axios.get(url).then((res) => {
      setUserfeeds((prev) => [...prev, ...res.data.userfeeds]);
      setCurrentPage((prev) => prev + 1);
      setIsLoadingNextList(false);
      setIsLastPage(res.data.isLastPage);
    });
  }, [currentPage, isLoadingNextList, isLastPage, setIsLoadingNextList, companyId]);

  useEffect(() => {
    loadNextList();
  }, []);

  const handleScrollEvent = useCallback(() => {
    if (!ancLastItemRef.current) {
      return;
    }
    
    const ancPosition = ancLastItemRef.current.offsetTop;
    const scrolled = scrollRef.current.scrollTop;

    if (
      scrolled > ancPosition - 1000 &&
      scrolled < ancPosition &&
      isEnableNextLoad.current
    ) {
      isEnableNextLoad.current = false;
      loadNextList();
    }
  }, [ancLastItemRef, isEnableNextLoad, loadNextList]);

  useEffect(() => {
    if (isLoadingNextList) {
      isEnableNextLoad.current = false;
    } else {
      isEnableNextLoad.current = true;
    }

    if (typeof scrollRef.current !== 'undefined') {
      if (isLastPage) {
        scrollRef.current.removeEventListener('scroll', handleScrollEvent);
      } else {
        scrollRef.current.addEventListener('scroll', handleScrollEvent);
      }

      return () => {
        scrollRef.current.removeEventListener('scroll', handleScrollEvent);
      };
    }
  }, [isLastPage, handleScrollEvent]);

  return ( 
    <div className="col-md-4 d-none d-md-block">
      <div className='row'>
        <a href={`/community/${hashedCompanyId}/userfeeds`} className="ml-4 mr-3 text-black-20 text-fz-18px"><svg className="svg-inline--fa fa-bars fa-w-14" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="bars" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"></path></svg></a>

        <div className="text-fz-12px d-flex justify-content-start font-weight-bold text-secondary mt-1" style={{height: '30px'}}>参加中</div>
      </div>

      <div
        id="scrollRef"
        ref={scrollRef} 
        style={{ 
          height: 'calc(100vh - 190px)', 
          overflowY: 'scroll' 
        }}
      >
        {userfeeds.map((userfeed, index) => (
          <FeedItem
            key={`${userfeed.id}_${index}`}
            currentUser={currentUser}
            userfeed={userfeed}
            userfeedId={userfeedId}
            hashedCompanyId={hashedCompanyId}
          />
        ))}
        {!isLastPage && !isLoadingNextList && (
          <p 
            id="read-more" 
            className="text-info text-fz-11px mt-1 mb-0 mr-3 cursor-pointer text-right"
            onClick={loadNextList}
          >
            もっと見る
          </p>
        )}
        {isLoadingNextList && (
          <div className="d-flex mx-auto py-4 align-items-center justify-content-center">
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        )}
        <div id="ancLastItemRef" ref={ancLastItemRef} />
      </div>
    </div>
  )
};


export default ActiveUserfeedColumn;